import React, { useState, lazy, Suspense } from 'react';
import cn from 'classnames';
import ImageLink from './ImageLink';
import { useHeaderRndVideos } from 'staticQueries/header-rnd-videos';
import { useStateModal } from 'utils/hooks';
import { pushHeaderEvent } from '../../../utils';
import * as styles from './TabsWithLinks.module.scss';

const PlayerModal = lazy(() => import('components/Modals/PlayerModal'));

export default function ArticleCards() {
  const videos = useHeaderRndVideos();
  const { modalState, showModal, hideModal } = useStateModal();
  const [videoSrc, setVideoSrc] = useState(null);

  const openModal = (videoId, title) => () => {
    setVideoSrc(videoId);
    showModal();
    pushHeaderEvent('click_on_insight_card', title, 'Desktop');
  };

  return (
    <div className={cn(styles.linksWrap, styles.imagesWrap)}>
      {videos?.map(({ title, cover, videoId }, i) => {
        return (
          <ImageLink
            key={`video-${i}`}
            title={title}
            img={{ desktop: cover.url }}
            onClick={openModal(videoId, title)}
          />
        );
      })}
      <Suspense fallback={null}>
        <PlayerModal
          isOpen={modalState.isOpen}
          closeModalCallback={hideModal}
          data={{ videoSrc }}
        />
      </Suspense>
    </div>
  );
}
